export default "__VITE_ASSET__IKxuQmACIf7_OOvxCUiXmQ__"